export const ADMIN_INFO = 'ADMIN_INFO';
export const GOOGLE_INFO = 'GOOGLE_INFO';
export const UPDATE_MEMBER_LEAVE = 'UPDATE_MEMBER_LEAVE'
export const UPDATE_MEMBER = 'UPDATE_MEMBER'
export const UPDATE_MEMBER_OK = 'UPDATE_MEMBER_OK'
export const GET_TICKET_LAST = 'GET_TICKET_LAST';
export const UPDATE_COMPANY_SIMPLE = 'UPDATE_COMPANY_SIMPLE';


// WEBPACK FOOTER //
// ./src/constants/myInfo.js